module.exports = __webpack_public_path__ + "img/TOMMputer.1f54694c.svg";